"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.throwReceiptErrorsFromOutcomes = exports.parseOutcomeValue = void 0;
const utils_1 = require("@near-js/utils");
const buffer_1 = require("buffer");
const Parser_1 = require("./Parser");
const errors_1 = require("../errors");
function parseOutcomeValue(outcome, parser = Parser_1.Parser.json()) {
    const successValue = outcome.status.SuccessValue;
    if (successValue) {
        const valueRaw = buffer_1.Buffer.from(successValue, 'base64');
        return parser.parse(valueRaw);
    }
    else if (successValue === '') {
        return undefined;
    }
    else {
        throw new errors_1.ParseOutcomeError(`Execution status is Failure`);
    }
}
exports.parseOutcomeValue = parseOutcomeValue;
function throwReceiptErrorsFromOutcomes(outcomes) {
    const errors = outcomes.map((outcome) => getReceiptErrorsFromOutcome(outcome)).flat();
    if (errors.length !== 0) {
        throw new errors_1.ReceiptError(errors);
    }
}
exports.throwReceiptErrorsFromOutcomes = throwReceiptErrorsFromOutcomes;
function getReceiptErrorsFromOutcome(outcome) {
    const errors = [];
    outcome.receipts_outcome.forEach((receipt) => {
        const status = receipt.outcome.status;
        if (typeof status !== 'string' && status.Failure) {
            const serverError = (0, utils_1.parseRpcError)(status.Failure);
            const errorMessage = JSON.parse(serverError.message);
            errors.push(errorMessage);
        }
    });
    return errors;
}
//# sourceMappingURL=outcome.js.map